import { FlowOrigin } from 'shared/api/common/schemas/flow/origin'

export const isExternalFlowOrigin = (origin: FlowOrigin) => {
  return origin === FlowOrigin.icon
}
